import { render, staticRenderFns } from "./main-view.vue?vue&type=template&id=2173efae&scoped=true&lang=pug"
import script from "./main-view.js?vue&type=script&lang=js&external"
export * from "./main-view.js?vue&type=script&lang=js&external"
import style0 from "./main-view.vue?vue&type=style&index=0&id=2173efae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2173efae",
  null
  
)

export default component.exports